// #664 — the nav badge of the admin link and the number on the Requests tab
// show ONE counter (`GET /api/users/admin/pending-counts`). The Layout reads
// it on a route change. After an answer on the Admin page, the page reads the
// counter again and announces the new total here, so the nav and the tab
// agree with no second request.

/** The name of the window event that carries the new total in `detail`. */
export const PENDING_COUNTS_EVENT = 'lmf:pending-counts';

/** Tell the Layout the new total of the pending requests. */
export function announcePendingCounts(total: number): void {
  window.dispatchEvent(new CustomEvent<number>(PENDING_COUNTS_EVENT, { detail: total }));
}
